import SupportPage from '../../js/pages/SupportPage';

export default SupportPage;
